import React from 'react';
import ReactDOM from 'react-dom';
import QuizApp from './quizapp.js';

ReactDOM.render(<QuizApp />, document.getElementById('root'));